__turbopack_context__.v({
  "emergency": "EmergencyBanner-module-scss-module__zGloMq__emergency",
  "emergency__content": "EmergencyBanner-module-scss-module__zGloMq__emergency__content",
  "emergency__content-wrapper": "EmergencyBanner-module-scss-module__zGloMq__emergency__content-wrapper",
  "emergency__dismiss": "EmergencyBanner-module-scss-module__zGloMq__emergency__dismiss",
  "emergency__inner": "EmergencyBanner-module-scss-module__zGloMq__emergency__inner",
  "emergency__link": "EmergencyBanner-module-scss-module__zGloMq__emergency__link",
  "emergency__link-arrow": "EmergencyBanner-module-scss-module__zGloMq__emergency__link-arrow",
  "emergency__link-text": "EmergencyBanner-module-scss-module__zGloMq__emergency__link-text",
  "emergency__message": "EmergencyBanner-module-scss-module__zGloMq__emergency__message",
});
